/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank-employee.reducer';

export const BloodBankEmployeeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankEmployeeEntity = useAppSelector(state => state.bloodBankEmployee.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankEmployeeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.detail.title">BloodBankEmployee</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.id}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.education">Education</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.training">Training</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.achievements}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.name">Name</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.email">Email</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.email}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.dateOfBirth}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.gender}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.bloodGroup}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankEmployeeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.bloodBank">Blood Bank</Translate>
          </dt>
          <dd>{bloodBankEmployeeEntity.bloodBank ? bloodBankEmployeeEntity.bloodBank.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.user">User</Translate>
          </dt>
          <dd>{bloodBankEmployeeEntity.user ? bloodBankEmployeeEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.contactDetails">Contact Details</Translate>
          </dt>
          <dd>{bloodBankEmployeeEntity.contactDetails ? bloodBankEmployeeEntity.contactDetails.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank-employee" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank-employee/${bloodBankEmployeeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankEmployeeDetail;
